import React, { useEffect, useState } from 'react';
import { NvidiaGUIIcon } from '@nv-brand-assets/react-icons';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container } from 'react-bootstrap';
import './Navbar.scss';
import OrderStages from '../OrderStage/OrderStage';
import { useHeaderMenu } from "../../contexts/login.context";
import { useLocation } from 'react-router-dom';
import LogoutModal from './LogoutModal/LogoutModal';
import { useTranslation } from 'react-i18next';
import { config } from "../../config";
import { useLocalization } from '../../contexts/LocalizationContext';

function HeaderNavbar() {
  const { loginStatus, isDownload, cartCategory } = useHeaderMenu();
  const location = useLocation();
  const [currentStep, setCurrentStep] = useState<string>('');
  const [modalShow, setModalShow] = React.useState(false);
  const { t } = useTranslation();
  const { locale } = useLocalization();
  const pathSegments = location.pathname.split('/');

  const handleSSOLogin = () => {
    const page = window.location.pathname.split("/")[3]
    if (page === 'thankyou' || page === 'empty') {
      window.location.href = `${config.bcSSOLoginUrl}${locale}/account/my-orders`
    } else {
      window.location.href = `${config.bcSSOLoginUrl}${locale}/software/cart`
    }
  }

  useEffect(() => {
    let lastParameter = pathSegments[pathSegments.length - 1] || pathSegments[pathSegments.length - 2];
    if (lastParameter === 'cart' && isDownload) {
      setCurrentStep(lastParameter);
    }
    if (lastParameter === 'user' || (lastParameter === 'cart' && !isDownload)) {
      setCurrentStep(pathSegments[pathSegments.length - 1])
    } else {
      setCurrentStep(lastParameter);
    }
    setCurrentStep(lastParameter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathSegments, isDownload])

  return (

    <div className="header-navigation" role="navigation" aria-label="Main Navigation">
      <nav aria-label="Main navigation">
        <Navbar bg="dark" variant="dark" expand="lg">
          <Container>
            <Navbar.Brand href={locale === 'en-ph' ? 'https://www.nvidia.com/en-ph/geforce/' : `https://www.nvidia.com/${locale === 'es-mx' ? 'es-la' : locale}/`} aria-label="NVIDIA Logo Container">          <svg role="img"
              aria-label="NVIDIA Logo"
              focusable="false" id="NVIDIA_Logo_V" data-name="NVIDIA Logo V" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 974.7 179.71" width="110" height="24">
              <title id="nvidia-logo-title">NVIDIA Logo</title>
              <defs>
                <style>{`.cls-1{fill:#fff}`}</style>
              </defs>
              <path id="Reg" className="cls-1" d="M962.11 144.13v-2.69h1.73c.94 0 2.23.07 2.23 1.22s-.66 1.47-1.78 1.47h-2.18m0 1.89h1.16l2.68 4.71h2.94l-3-4.9a2.66 2.66 0 002.79-2.91c0-2.56-1.77-3.39-4.76-3.39h-4.33v11.19h2.49V146m12.59-.88c0-6.57-5.11-10.39-10.8-10.39s-10.83 3.81-10.83 10.39 5.1 10.4 10.83 10.4 10.8-3.83 10.8-10.4m-3.12 0a7.67 7.67 0 01-7.68 8 8 8 0 117.71-7.98z" /><path id="NVIDIA" className="cls-1" d="M578.25 34v118h33.31V34h-33.31zm-262.07-.2v118.12h33.61V60.23l26.21.09c8.63 0 14.59 2.07 18.74 6.5 5.27 5.62 7.42 14.67 7.42 31.23v53.87h32.56V86.66C434.74 40.08 405 33.8 376 33.8h-59.82zm315.7.2v118h54c28.79 0 38.18-4.79 48.35-15.52 7.18-7.54 11.82-24.08 11.82-42.16 0-16.58-3.93-31.37-10.78-40.58C723 37.18 705.18 34 678.64 34h-46.76zm33 25.68h14.32c20.78 0 34.22 9.33 34.22 33.54s-13.42 33.52-34.17 33.52h-14.32V59.65zM530.21 34l-27.8 93.48L475.77 34h-36l38 118h48l38.45-118h-34zm231.37 118h33.32V34h-33.32v118zM855 34l-46.54 117.88h32.85l7.36-20.88h55.05l7 20.83h35.66L899.48 34H855zm21.63 21.5l20.18 55.22h-41z" /><path id="Eye_Mark" data-name="Eye Mark" d="M101.33 53.63V37.39c1.58-.11 3.17-.2 4.79-.25 44.4-1.4 73.53 38.15 73.53 38.15S148.19 119 114.46 119a40.91 40.91 0 01-13.13-2.1V67.67c17.29 2.09 20.76 9.72 31.15 27l23.12-19.45S138.73 53.1 110.29 53.1a83.81 83.81 0 00-9 .53m0-53.62v24.24c1.59-.13 3.19-.23 4.79-.29 61.74-2.08 102 50.64 102 50.64s-46.2 56.18-94.34 56.18a71 71 0 01-12.42-1.09v15a81.75 81.75 0 0010.34.67c44.79 0 77.19-22.87 108.56-49.95 5.2 4.16 26.49 14.29 30.87 18.73-29.83 25-99.33 45.09-138.74 45.09-3.8 0-7.45-.23-11-.57v21.06h170.24V0H101.33zm0 116.89v12.8C59.9 122.3 48.4 79.24 48.4 79.24s19.89-22 52.93-25.61v14h-.06c-17.34-2.05-30.88 14.15-30.88 14.15S78 109 101.33 116.89M27.75 77.37s24.55-36.23 73.58-40V24.25C47 28.61 0 74.6 0 74.6s26.63 77 101.33 84.05v-14c-54.81-6.87-73.58-67.28-73.58-67.28z" fill="#76b900" />
            </svg>
            </Navbar.Brand>

            <Nav className={isDownload ? 'mr-auto border-0' : 'mr-auto'}>
              <NavDropdown title={
                <>
                  <UserTitleWithIcon />
                  <span className="visually-hidden">User account menu</span>
                </>
              } className="dr_myAccountLink dropdown-left" id="basic-nav-dropdown" aria-haspopup="true" aria-label="User account menu">
                <NavDropdown.Item aria-label={t('CANDR11')} href={locale === "ko-kr" ? "https://www.nvidia.com/ko-kr/support/" : config.bcSupportUrl} className='dr_menuLink' target="_blank" rel="noopener">
                  <NvidiaGUIIcon
                    iconName="help-circle"
                    width="48px"
                    height="48px"
                    color="#000000"
                    variant="line"
                  />
                  {t('CANDR11')}
                </NavDropdown.Item>
                {!loginStatus &&
                  <NavDropdown.Item aria-label={t('SITE_LOGIN_PAGE_TITLE')} onClick={() => handleSSOLogin()} className='dr_menuLink'>
                    <NvidiaGUIIcon
                      iconName="arrow-left-max"
                      width="48px"
                      height="48px"
                      color="#000000"
                      variant="line"
                    />
                    {t('SITE_LOGIN_PAGE_TITLE')}
                  </NavDropdown.Item>}
                {loginStatus &&
                  <>
                    <NavDropdown.Item aria-label={t('MY_ACCOUNT_MENU')} href={config.bcOrdersUrl} className='dr_menuLink' target="_blank" rel="noopener">
                      <UserIcon fillColor="#000" />
                      {t('MY_ACCOUNT_MENU')}
                    </NavDropdown.Item>

                    {(cartCategory !== 'DLI' || currentStep === 'thankyou') &&
                      <NavDropdown.Item aria-label={t('LOGOUT')} onClick={() => setModalShow(true)} className='dr_menuLink'>
                        <NvidiaGUIIcon
                          iconName="arrow-right-max"
                          width="48px"
                          height="48px"
                          color="#000000"
                          variant="line"
                        />
                        {t('LOGOUT')}
                      </NavDropdown.Item>}
                  </>}
              </NavDropdown>
            </Nav>
          </Container>
        </Navbar>
      </nav>
      {
        (isDownload && (currentStep !== 'cart')) &&
        ((isDownload && (currentStep === 'verify' || currentStep === 'thankyou')) ||
          (!isDownload && (currentStep !== 'cart' && currentStep !== 'login')) ||
          (!isDownload && (currentStep === 'cart' && loginStatus))) && currentStep !== 'empty' && <OrderStages />
      }
      <LogoutModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div >
  );
}

const UserTitleWithIcon = () => {
  return (
    <span aria-label="User Account">
      <UserIcon fillColor="#fff" />
    </span>
  );
}
const UserIcon = ({ fillColor }: { fillColor: string }) => {
  return (
    <svg id="Icon_Account_32px" data-name="Icon Account 32px" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path">
          <circle id="Circle_Mask" data-name="Circle Mask" cx="10.5" cy="10.5" r="10.5" fill="none" stroke={fillColor} stroke-width="1.5" />
        </clipPath>
      </defs>
      <g id="Group_33" data-name="Group 33" transform="translate(1.5 1.5)" clip-path="url(#clip-path)">
        <g id="Person" transform="translate(3.309 3.75)">
          <g id="Body" transform="translate(-168.412 -102.25)" fill="none" stroke-miterlimit="10">
            <path d="M180.853,112h-10.5l-1.941,7.244,2.691,1.006h9l2.691-1.006Z" stroke="none" />
            <path d="M 171.5039367675781 113.5 L 170.2134094238281 118.3163299560547 L 171.3740386962891 118.75 L 179.8318634033203 118.75 L 180.9924926757812 118.3163299560547 L 179.7019653320312 113.5 L 171.5039367675781 113.5 M 170.3529510498047 112 L 180.8529510498047 112 L 182.7940979003906 119.2444534301758 L 180.1029510498047 120.25 L 171.1029510498047 120.25 L 168.4118041992188 119.2444534301758 L 170.3529510498047 112 Z" stroke="none" fill={fillColor} />
          </g>
          <g id="Head" transform="translate(2.691)" fill="none" stroke={fillColor} stroke-miterlimit="10" stroke-width="1.5">
            <circle cx="4.5" cy="4.5" r="4.5" stroke="none" />
            <circle cx="4.5" cy="4.5" r="3.75" fill="none" />
          </g>
        </g>
      </g>
      <g id="Circle" transform="translate(1.5 1.5)" fill="none" stroke={fillColor} stroke-miterlimit="10" stroke-width="1.5">
        <circle cx="10.5" cy="10.5" r="10.5" stroke="none" />
        <circle cx="10.5" cy="10.5" r="9.75" fill="none" />
      </g>
      <g id="Container" fill="none" stroke={fillColor} stroke-width="1.5" opacity="0">
        <rect width="24" height="24" stroke="none" />
        <rect x="0.75" y="0.75" width="22.5" height="22.5" fill="none" />
      </g>
    </svg>
  )
}
export default HeaderNavbar;